var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Archivos"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('archivos')],1)]),_c('vs-tab',{attrs:{"label":"Temas"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('temas')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }